import React from 'react';
import { Link } from 'react-router-dom';
import deckleproImg from '../images/decklepro.png';
import entrylessLogo from '../images/EntryLess/Logo.png';
import entrylessName from '../images/EntryLess/Name.png';

const Product = () => {
    const products = [
        {
            id: 'decklepro',
            kicker: 'Paper mill optimization',
            name: (
                <>
                    <span style={{ color: 'var(--anmatics-dark)' }}>Deckle</span>
                    <span style={{ color: 'var(--anmatics-secondary)' }}>Pro</span>
                </>
            ),
            description:
                'Deckle matching and reel slitting optimization software for paper mills. Plan faster, reduce trim waste, and manage configurable workflows for orders, stock, production, dispatch, invoices, gate passes, lab reports, and mill documents in one system.',
            points: ['Optimization engine', 'Configurable workflows', 'Reports & documents'],
            media: (
                <div className="product-logo-frame">
                    <img
                        alt="DecklePro deckle matching software logo"
                        height={120}
                        width={150}
                        src={deckleproImg}
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            ),
            action: (
                <Link to="/deckle-matching-software" className="btn btn-gradient btn-lg rounded-pill shadow-sm">
                    View DecklePro
                </Link>
            ),
        },
        {
            id: 'entryless',
            kicker: 'Accounting automation',
            name: 'EntryLess',
            description:
                'Bank statement to import-ready Excel software for accounting firms. EntryLess helps teams process statements across major banks, review ledger mappings, connect Miracle or TallyPrime data, and export clean import-ready Excel files with full control.',
            points: ['Bank statement processing', 'Miracle & TallyPrime', 'Review-first export'],
            media: (
                <div className="product-logo-frame entryless-logo-frame">
                    <div className="entryless-brand-lockup" aria-label="EntryLess">
                        <img
                            alt="EntryLess logo icon"
                            className="entryless-logo-img"
                            src={entrylessLogo}
                            loading="lazy"
                            decoding="async"
                        />
                        <img
                            alt="EntryLess wordmark"
                            className="entryless-name-img"
                            src={entrylessName}
                            loading="lazy"
                            decoding="async"
                        />
                    </div>
                </div>
            ),
            action: (
                <a
                    href="https://www.entryless.in/"
                    className="btn btn-gradient btn-lg rounded-pill shadow-sm"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Explore EntryLess
                </a>
            ),
        },
    ];

    return (
        <section id="product" className="product-section product-lean py-5">
            <div className="container" data-aos="fade-up">
                <div className="product-section-heading text-center mx-auto mb-5">
                    <span className="section-kicker">Products</span>
                    <h2 className="section-title mb-3">Products built by Anmatics</h2>
                    <p className="section-subtitle mb-0">
                        Focused software products for operational teams that need accuracy, review control, and
                        measurable process improvement.
                    </p>
                </div>

                <div className="row g-4 justify-content-center product-grid">
                    {products.map((product) => (
                        <div className="col-lg-6" key={product.id}>
                            <article className="product-card product-panel p-4 p-md-5 shadow-sm h-100" id={product.id}>
                                <div className="product-card-inner">
                                    <div className="text-center">
                                        {product.media}
                                    </div>
                                    <div className="product-content">
                                        <span className="section-kicker">{product.kicker}</span>
                                        <h2 className="mb-3">{product.name}</h2>
                                        <p className="text-muted mb-4">{product.description}</p>
                                        <div className="product-points mb-4">
                                            {product.points.map((point) => (
                                                <span key={point}>{point}</span>
                                            ))}
                                        </div>
                                        {product.action}
                                    </div>
                                </div>
                            </article>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Product;
